import { createReducer } from 'redux-act';
import actions from '../actions/trainingCertificatesActions';

const initialState = {
    addTrainingCertificatePending: false,
    addTrainingCertificateRes: null,
    addTrainingCertificateError: null,

    getTrainingCertificatesPending: false,
    getTrainingCertificatesRes: null,
    getTrainingCertificatesError: null,

    updateTrainingCertificatePending: false,
    updateTrainingCertificateRes: null,
    updateTrainingCertificateError: null,

    deleteTrainingCertificatePending: false,
    deleteTrainingCertificateRes: null,
    deleteTrainingCertificateError: null,

    getAllTrainingCertificatesPending: false,
    getAllTrainingCertificatesRes: null,
    getAllTrainingCertificatesError: null,

};
/* Add Qualification  Reducers */
const handleAddTrainingCertificateRequest = state => {
    return {
        ...state,
        ...{
            addTrainingCertificatePending: true,
            addTrainingCertificateRes: null,
            addTrainingCertificateError: null,
        },
    };
};
const handleAddTrainingCertificateSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addTrainingCertificatePending: false,
            addTrainingCertificateRes: payload,
            addTrainingCertificateError: null,
        },
    };
};
const handleAddTrainingCertificateError = (state, payload) => ({
    ...state,
    ...{
        addTrainingCertificatePending: false,
        addTrainingCertificateRes: null,
        addTrainingCertificateError: payload,
    },
});


/* Get Training Certificates  Reducers */
const handleGetTrainingCertificatesRequest = state1 => {
    return {
        ...state1,
        ...{
            getTrainingCertificatesPending: true,
            getTrainingCertificatesRes: null,
            getTrainingCertificatesError: null,
        },
    };
};
const handleGetTrainingCertificatesSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getTrainingCertificatesPending: false,
            getTrainingCertificatesRes: payload,
            getTrainingCertificatesError: null,
        },
    };
};
const handleGetTrainingCertificatesError = (state1, payload) => ({
    ...state1,
    ...{
        getTrainingCertificatesPending: false,
        getTrainingCertificatesRes: null,
        getTrainingCertificatesError: payload,
    },
});



/* Update Training Certificate  Reducers */
const handleUpdateTrainingCertificateRequest = state1 => {
    return {
        ...state1,
        ...{
            updateTrainingCertificatePending: true,
            updateTrainingCertificateRes: null,
            updateTrainingCertificateError: null,
        },
    };
};
const handleUpdateTrainingCertificateSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateTrainingCertificatePending: false,
            updateTrainingCertificateRes: payload,
            updateTrainingCertificateError: null,
        },
    };
};
const handleUpdateTrainingCertificateError = (state1, payload) => ({
    ...state1,
    ...{
        updateTrainingCertificatePending: false,
        updateTrainingCertificateRes: null,
        updateTrainingCertificateError: payload,
    },
});


/* Delete Training Certificate  Reducers */
const handleDeleteTrainingCertificateRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteTrainingCertificatePending: true,
            deleteTrainingCertificateRes: null,
            deleteTrainingCertificateError: null,
        },
    };
};
const handleDeleteTrainingCertificateSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteTrainingCertificatePending: false,
            deleteTrainingCertificateRes: payload,
            deleteTrainingCertificateError: null,
        },
    };
};
const handleDeleteTrainingCertificateError = (state1, payload) => ({
    ...state1,
    ...{
        deleteTrainingCertificatePending: false,
        deleteTrainingCertificateRes: null,
        deleteTrainingCertificateError: payload,
    },
});

// Get All Training Certificates  Reducers */
const handleGetAllTrainingCertificatesRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllTrainingCertificatesPending: true,
            getAllTrainingCertificatesRes: null,
            getAllTrainingCertificatesError: null,
        },
    };
};
const handleGetAllTrainingCertificatesSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllTrainingCertificatesPending: false,
            getAllTrainingCertificatesRes: payload,
            getAllTrainingCertificatesError: null,
        },
    };
};
const handleGetAllTrainingCertificatesError = (state1, payload) => ({
    ...state1,
    ...{
        getAllTrainingCertificatesPending: false,
        getAllTrainingCertificatesRes: null,
        getAllTrainingCertificatesError: payload,
    },
});




// Clear Training Certificate Store */
const clearTrainingCertificateStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_TRAINING_CERTIFICATE_STORE':
            return {
                ...state,
                ...{
                    addTrainingCertificatePending: false,
                    addTrainingCertificateRes: null,
                    addTrainingCertificateError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_TRAINING_CERTIFICATE_STORE':
            return {
                ...state,
                ...{
                    updateTrainingCertificatePending: false,
                    updateTrainingCertificateRes: null,
                    updateTrainingCertificateError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_TRAINING_CERTIFICATE_STORE':
            return {
                ...state,
                ...{
                    deleteTrainingCertificatePending: false,
                    deleteTrainingCertificateRes: null,
                    deleteTrainingCertificateError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addTrainingCertificateRequest]: handleAddTrainingCertificateRequest,
        [actions.addTrainingCertificateSuccess]: handleAddTrainingCertificateSuccess,
        [actions.addTrainingCertificateError]: handleAddTrainingCertificateError,

        [actions.getTrainingCertificatesRequest]: handleGetTrainingCertificatesRequest,
        [actions.getTrainingCertificatesSuccess]: handleGetTrainingCertificatesSuccess,
        [actions.getTrainingCertificatesError]: handleGetTrainingCertificatesError,

        [actions.updateTrainingCertificateRequest]: handleUpdateTrainingCertificateRequest,
        [actions.updateTrainingCertificateSuccess]: handleUpdateTrainingCertificateSuccess,
        [actions.updateTrainingCertificateError]: handleUpdateTrainingCertificateError,

        [actions.deleteTrainingCertificateRequest]: handleDeleteTrainingCertificateRequest,
        [actions.deleteTrainingCertificateSuccess]: handleDeleteTrainingCertificateSuccess,
        [actions.deleteTrainingCertificateError]: handleDeleteTrainingCertificateError,

        [actions.getTrainingCertificatesRequest]: handleGetTrainingCertificatesRequest,
        [actions.getTrainingCertificatesSuccess]: handleGetTrainingCertificatesSuccess,
        [actions.getTrainingCertificatesError]: handleGetTrainingCertificatesError,

        [actions.getAllTrainingCertificatesRequest]: handleGetAllTrainingCertificatesRequest,
        [actions.getAllTrainingCertificatesSuccess]: handleGetAllTrainingCertificatesSuccess,
        [actions.getAllTrainingCertificatesError]: handleGetAllTrainingCertificatesError,

        [actions.handleClearTrainingCertificateStore]: clearTrainingCertificateStore,
    },
    initialState,
);